import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Session overrides applied on top of the backend icons so a change reflects
// instantly across every view (classId -> icon name).
export interface ClassIconsState {
  overrides: Record<string, string>;
}

const initialState: ClassIconsState = { overrides: {} };

// Stable reference for the fallback so selectors don't return a fresh object each
// call (a new ref would retrigger memos/effects downstream and loop renders).
const EMPTY_OVERRIDES: Record<string, string> = {};

export const classIconsSlice = createSlice({
  name: 'classIcons',
  initialState,
  reducers: {
    setClassIconOverride: (state: ClassIconsState, action: PayloadAction<{ classId: string; icon: string }>) => {
      state.overrides[action.payload.classId] = action.payload.icon;
    },
  },
});

export const selectClassIconOverrides = (state: RootState) => state.classIcons?.overrides ?? EMPTY_OVERRIDES;

export const { setClassIconOverride } = classIconsSlice.actions;

export default classIconsSlice.reducer;
